module.exports = __webpack_public_path__ + "static/img/other_08.5563fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/other_08.jpg
// module id = RJoe
// module chunks = 1